import React from 'react';
import {
  Box,
  Container,
  Typography,
  CardContent,
} from '@mui/material';
import Grid from '@mui/material/Grid';
import { useLanguage } from '../contexts/LanguageContext';
import { clients } from '../data/clients';
import { Reveal, SpotCard, Glow, GridTexture, BRAND, BRAND_GRAD } from './premium';

const ClientsSection: React.FC = () => {
  const { t, language } = useLanguage();

  return (
    <Box sx={{ position: 'relative', overflow: 'hidden', py: { xs: 8, md: 12 }, backgroundColor: '#F6FAFF' }}>
      <Glow color="#6DABE4" top="-10%" right="-6%" size={440} opacity={0.12} />
      <GridTexture opacity={0.04} />
      <Container maxWidth="lg" sx={{ position: 'relative', zIndex: 1 }}>
        <Reveal>
          <Box sx={{ textAlign: 'center', mb: { xs: 5, md: 7 } }}>
            <Box sx={{ width: 40, height: 3, borderRadius: 3, background: BRAND_GRAD, mx: 'auto', mb: 2.5 }} />
            <Typography component="h2" sx={{ fontWeight: 600, color: '#1A2332', mb: 2, fontSize: { xs: '2rem', md: '2.6rem' }, letterSpacing: '-0.01em', textWrap: 'balance' }}>
              {t.clients.title}
            </Typography>
            <Typography variant="h6" sx={{ color: '#5b6a86', maxWidth: 600, mx: 'auto', lineHeight: 1.6, fontWeight: 400 }}>
              {t.clients.subtitle}
            </Typography>
          </Box>

          <Grid container spacing={4} justifyContent="center">
            {clients.map((client) => (
              <Grid size={{ xs: 12, sm: 6, md: 4 }} key={client.id}>
                <SpotCard sx={{ height: '100%', textAlign: 'center', borderRadius: '18px', border: '1px solid #E6EEF9', boxShadow: '0 12px 34px -18px rgba(0,85,184,0.14)' }}>
                  <CardContent sx={{ p: 4 }}>
                    <Box
                      sx={{
                        width: 170, height: 104, mx: 'auto', mb: 3, p: 3,
                        display: 'flex', alignItems: 'center', justifyContent: 'center',
                        borderRadius: '14px',
                        background: client.darkLogo ? 'linear-gradient(150deg,#0a1024,#13204a)' : 'linear-gradient(160deg,#FFFFFF,#F4F8FF)',
                        border: client.darkLogo ? '1px solid #13204a' : '1px solid #E6EEF9',
                      }}
                    >
                      {client.logoUrl ? (
                        <Box
                          component="img"
                          src={typeof client.logoUrl === 'string' ? client.logoUrl : client.logoUrl[language]}
                          alt={`${client.name} Logo`}
                          sx={{ maxWidth: 130, maxHeight: 70, objectFit: 'contain', filter: client.darkLogo ? 'none' : 'grayscale(15%)', transition: 'filter .3s ease', '&:hover': { filter: client.darkLogo ? 'none' : 'grayscale(0%)' } }}
                        />
                      ) : (
                        <Typography variant="h6" sx={{ color: BRAND, fontWeight: 700 }}>{client.name}</Typography>
                      )}
                    </Box>
                    <Typography variant="h6" sx={{ fontWeight: 600, color: '#1A2332', mb: 1 }}>{client.name}</Typography>
                    <Typography variant="body2" sx={{ color: '#5b6a86', mb: 2 }}>{client.industry[language]}</Typography>
                    <Typography variant="body2" sx={{ color: BRAND, fontSize: '0.9rem', fontWeight: 500 }}>{client.project[language]}</Typography>
                  </CardContent>
                </SpotCard>
              </Grid>
            ))}
          </Grid>
        </Reveal>
      </Container>
    </Box>
  );
};

export default ClientsSection;
